import { FC } from "react";

import { AccessibilityProps } from "capitalrx-components-2.0/lib/AccessibilityProps";
import { BaseProps } from "capitalrx-components-2.0/lib/BaseProps";
import { useValidity } from "capitalrx-components-2.0/lib/forms/ValidityGroup";
import { getHtmlPropsFromBaseProps } from "capitalrx-components-2.0/lib/utilities";

import styles from "./styles.module.css";

/**
 * The `Error` component properties.
 */

export interface ErrorProps extends BaseProps, AccessibilityProps {
  /**
   * The ID of the component the error belongs to.
   */
  readonly forId?: string;
}

/**
 * An input component error block.
 */
export const Error: FC<ErrorProps> = (props) => {
  const { forId, "aria-live": ariaLive, role } = props;
  const [invalid, error] = useValidity();

  const baseHtmlProps = getHtmlPropsFromBaseProps(props, {
    className: [styles.Error, "error"],
    testIdPrefix: "error",
  });
  const { className: _className, ...outputHtmlProps } = baseHtmlProps;

  if (!error || !invalid) return null;

  return (
    <output {...outputHtmlProps} id={forId} htmlFor={forId} aria-atomic="true" aria-live={ariaLive} role={role} className={styles.Error}>
      {error}&nbsp;
    </output>
  );
};
